module.exports = __webpack_public_path__ + "img/seminario_sennheiser_2014.804f7aa6.jpg";